// components/CostBreakdownTable.tsx
"use client";

import * as React from "react";
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableFooter,
} from "@mui/material";

export default function CostBreakdownTable({
    data,
    surfaceColor = "#f5f5f5",
    footerData = [{ item: "Total", amount: "16,000.00" }],
}) {
    const borderColor = "#E3E6EB";

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box sx={{ position: "relative", width: "100%" }}>
                {/* notches */}
                {/* left notch */}
                <Box
                    aria-hidden
                    sx={{
                        position: "absolute",
                        left: -9,
                        top: "22.5%",
                        transform: "translateY(-50%)",
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        bgcolor: surfaceColor, // cutout color (page background)
                        borderRight: `1px solid ${borderColor}`,  // 👈 half border visible
                        zIndex: 2,
                        pointerEvents: "none",
                    }}
                />

                {/* right notch */}
                <Box
                    aria-hidden
                    sx={{
                        position: "absolute",
                        right: -9,
                        top: "22.5%",
                        transform: "translateY(-50%)",
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        bgcolor: surfaceColor,
                        borderLeft: `1px solid ${borderColor}`,   // 👈 half border visible
                        zIndex: 2,
                        pointerEvents: "none",
                    }}
                />


                <TableContainer
                    component={Paper}
                    sx={{
                        overflow: "hidden",
                        borderRadius: 3,
                        boxShadow: "none",
                        border: `1px solid ${borderColor}`,
                        backgroundColor: "#fff",
                    }}
                >
                    <Table
                        sx={{
                            tableLayout: "fixed",
                            // vertical divider only for header/body
                            "& thead th:first-of-type, & tbody td:first-of-type": {
                                borderRight: `1px solid ${borderColor}`,
                            },
                            // header bottom rule
                            "& thead th": { borderBottom: `1px solid ${borderColor}` },
                            // remove default row borders
                            "& tbody td, & tfoot td": { borderBottom: "none" },
                            // typography + spacing
                            "& th": { fontWeight: 700, textAlign: "center", py: 2 },
                            "& td": { fontSize: 15, py: 1.5, textAlign: "center", color: "#4B5563" },
                        }}
                    >
                        {/* Force equal column widths */}
                        <colgroup>
                            <col style={{ width: "50%" }} />
                            <col style={{ width: "50%" }} />
                        </colgroup>

                        <TableHead>
                            <TableRow>
                                <TableCell>Item</TableCell>
                                <TableCell>Amount (AED)</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data?.map((row, i) => (
                                <TableRow key={`row-${i}`}>
                                    <TableCell>{row.item}</TableCell>
                                    <TableCell>{row.amount}</TableCell>
                                </TableRow>
                            ))}
                            {/* dashed divider before totals */}
                            <TableRow>
                                <TableCell colSpan={2} sx={{ py: 0, pt: "0 !important" }}>
                                    <Box sx={{ borderBottom: "1px dashed #D6DBE3", width: "100%" }} />
                                </TableCell>
                            </TableRow>
                        </TableBody>

                        <TableFooter>
                            {footerData?.map((row, i) => (
                                <TableRow key={`total-${i}`}>
                                    <TableCell sx={{ fontWeight: 700, color: "#2B2F33" }}>
                                        {row.item}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 700, color: "#2B2F33" }}>
                                        {row.amount}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableFooter>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}
